import React, { useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

function TotalGroupsRecord({ data }) {
	const { t } = useContext(TranslatorContext);

	console.log(data, 'total groups record');
	const navigate = useNavigate();

	const handleCardClick = (key) => {
		navigate(`/act-group-details/${key}`);
	};

	const totalGroupRecord = [
		{
			key: "total_groups",
			icon: "groups",
			trend: "family_restroom",
			title: "Total Groups",
			variant: "linear-gradient(to right, #6f2a91, #8e44ad, #b57fcf)", 
			icon_variant: "#53206f",
			number: data?.total_groups,
			percent: 95,
		},
		{
			key: "male_groups",
			icon: "male",
			trend: "male",
			title: "Total Male Groups",
			variant: "linear-gradient(to right, #1f5fa8, #3b9df3, #6fb5f7)",
			icon_variant: "#3286d6",
			number: data?.total_male_groups,
			percent: 30,
		},
		{
			key: "female_groups",
			icon: "female",
			trend: "female",
			title: "Total Female Groups",
			variant: "linear-gradient(to right, #e05c98, #ff5ca2, #ff85b9)", 
			icon_variant: "#e4548f",
			number: data?.total_female_groups,
			percent: 25,
		},
		{
			key: "savings",
			icon: "savings",
			trend: "child_care",
			title: "Total Savings",
			variant: "linear-gradient(to right, #cc6d1c, #e67e22, #ffb347)", 
			icon_variant: "#cc6d1c",
			number: data?.total_savings,
			percent: 45,
		},
	];

	return (
		<>
			{totalGroupRecord.map((item,index) => {
				return (
					<Col key={item.key}>
						<div
							className={`mc-ecommerce-card`}
							onClick={() => handleCardClick(item.key)}
							style={{
								background:
									"linear-gradient(to right, rgba(0,0,0,0.8), #077834)",
								cursor: "pointer",
							}}
						>
							<i
								className="mc-ecommerce-card-trend material-icons "
								style={{ color: "#077834" }}
							>
								{item.trend}
							</i>
							<div className="mc-ecommerce-card-head">
								<h4 className="mc-ecommerce-card-meta">
									<span>{item.title}</span>
									<span>{item.number}</span>
								</h4>
								<i
									className="mc-ecommerce-card-icon material-icons text-light"
									style={{ backgroundColor: "transparent" }}
								>
									{item.icon}
								</i>
							</div>
							<div className="mc-ecommerce-card-foot">
								<div className="mc-ecommerce-card-compare">
									{/* <mark>+ { percent }%</mark> */}
									<span>{t("All The Time")}</span>
								</div>
							</div>
						</div>
					</Col>
				);
			})}
		</>
	);
}

export default TotalGroupsRecord;
